import { removeDupes } from '../utils/helpers';

const teams = (state = {
    items: [],
    linkedTeams: [],
    fetched: false,
    error: false,
    loading: true,
    currentTeamFetched: false,
    shouldRefetchCurrentTeam: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'LOGOUT':
            return Object.assign({}, state, {
                items: [],
                fetched: false,
                error: false,
                loading: true,
                currentTeamFetched: false,
                shouldRefetchCurrentTeam: false
            });

        case 'TEAM_CHANGE':
            return Object.assign({}, state, {
                items: [],
                fetched: false,
                error: false,
                loading: true,
                currentTeamFetched: false,
                shouldRefetchCurrentTeam: false
            });

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                shouldRefetchCurrentTeam: true
            });

        case 'TEAMS_FETCH_SUCCEEDED':
            if (!action.payload.items) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([...state.items, ...action.payload.items]),
                fetched: true,
                error: false,
                loading: false
            });

        case 'LINKED_TEAMS_FETCH_SUCCEEDED':
            if (!action.payload.items) {
                return state;
            }

            return Object.assign({}, state, {
                linkedTeams: action.payload.items
            });

        case 'TEAM_DETAILS_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(team => Object.assign({}, team, action.payload.teamDetails))]
            });

        case 'TEAM_FETCH_REQUESTED':
            return Object.assign({}, state, {
                shouldRefetchCurrentTeam: false
            });

        case 'TEAM_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: removeDupes([Object.assign({}, action.payload.team, {
                    is_current: true,
                    shouldRefetch: false
                }), ...state.items]),
                currentTeamFetched: true
            });

        case 'TEAM_UPDATE_REQUESTED': {
            const teamProps = {...(action.payload.team || action.payload.teamProps)};

            if (teamProps.logoBase64) {
                teamProps.logo = teamProps.logoBase64;
                teamProps.logoBase64 = undefined;
            }

            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.is_current) {
                        return Object.assign({}, team, teamProps);
                    }

                    return team;
                })]
            });
        }

        case 'TEAM_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.url === action.payload.teamUrl) {
                        return Object.assign({}, team, action.payload.team);
                    }

                    return team;
                })]
            });

        case 'TEAM_INVITE_USERS_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.is_current) {
                        return Object.assign({}, team, {
                            members: [...new Set([...(team.members || []), ...action.payload.users])]
                        });
                    }

                    return team;
                })]
            });

        // case 'TEAM_REMOVE_REQUESTED':
        case 'TEAM_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(team => team && team.url !== action.payload.teamUrl)
            });

        case 'CHANGE_TEAM_PLAN':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.url === action.payload.teamUrl) {
                        team.subscriptionDetails.status = 'active';
                        team.status = 'active';
                        team.plan = action.payload.planId;

                        return Object.assign({}, team);
                    }

                    return team;
                })]
            });

        case 'USER_REMOVE_REQUESTED':
        case 'TEAM_USER_REMOVE_SOCKET':
        case 'USER_INVITE_CANCEL_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.is_current && !action.payload.projectId && !action.payload.projectsOnly) {
                        return Object.assign({}, team, {
                            members: (team.members || []).filter(userId => userId !== action.payload.userId)
                        });
                    }

                    return team;
                })]
            });


        case 'PROJECT_ADD_SOCKET':
        case 'PROJECT_INVITE_USERS_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.is_current) {
                        const projectMembers = action.payload.users || action.payload.project.members;

                        return Object.assign({}, team, {
                            members: [...new Set([...(team.members || []), ...projectMembers])]
                        });
                    }

                    return team;
                })]
            });

        case 'PROJECT_START_REQUESTED':
        case 'PROJECT_START_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items.map(team => {
                    if (team.is_current) {
                        return Object.assign({}, team, {
                            start_passed: true
                        });
                    }

                    return team;
                })]
            });

        default:
            return state;
    }
}

export default teams;
